import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import Logo from './Logo';
import { submitEmail, contactInfo } from '../mock';
import { toast } from 'sonner';
import { Input } from './ui/input';
import { Button } from './ui/button';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      await submitEmail(email);
      toast.success('Thank you for subscribing!');
      setEmail('');
    } catch (error) {
      toast.error('Failed to subscribe. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#2D0A14] via-[#3D1018] to-[#2D0A14] text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-noise opacity-40\"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <Logo className="brightness-0 invert" />
            </div>
            <p className="text-gray-400 text-sm">
              Professional residential appraisal services in the Twin Cities metro area and Wisconsin. Accurate, timely, and trusted.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4 text-[#E8D5C4]">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#D4A574] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-[#D4A574] transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/links" className="text-gray-400 hover:text-[#D4A574] transition-colors">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#D4A574] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4 text-[#E8D5C4]">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#D4A574]" />
                <span>{contactInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#D4A574]" />
                <span>{contactInfo.email}</span>
              </li>
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#D4A574]" />
                <span>{contactInfo.address}</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="font-semibold text-lg mb-4 text-[#E8D5C4]">Stay Updated</h3>
            <p className="text-gray-400 text-sm mb-4">
              Subscribe to receive market insights and updates.
            </p>
            <form onSubmit={handleEmailSubmit} className="flex flex-col gap-2">
              <Input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-[#3D1018] border-[#D4A574]/30 text-white placeholder:text-gray-400"
              />
              <Button
                type="submit"
                disabled={loading}
                className="bg-gradient-to-r from-[#D4A574] to-[#C9A97E] hover:from-[#C9A97E] hover:to-[#B8976D] text-gray-900 font-semibold"
              >
                {loading ? 'Subscribing...' : 'Subscribe'}
              </Button>
            </form>
          </div>
        </div>

        <div className="border-t border-[#D4A574]/20 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} St. Croix Appraisals. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;